import React from 'react';
import { useStore } from 'common/store';
import Information from 'dashboard409a/pages/Information/Information';
import { useCompanyMeasurementDateFilter } from 'services/hooks';
import { MeasurementDate } from '../../api';

const RequestDocumentsView = () => {
  const [{ companyInfo }] = useStore();
  const { selectedMeasurementDate, MDDialogue, measurementDates } = useCompanyMeasurementDateFilter();

  return (
    <>
      <Information
        is409a={false}
        currentCompany={companyInfo}
        currentMeasurementDateId={selectedMeasurementDate?.id}
        currentCompanyMeasurementDateId={selectedMeasurementDate?.cmd_id as number}
        measurementDates={measurementDates}
        selectedMeasurementDate={selectedMeasurementDate as MeasurementDate}
      />
      <MDDialogue />
    </>
  );
};

export default RequestDocumentsView;
